module.exports = __webpack_public_path__ + "img/ontdekken in het bos.9349fb23.jpg";